const prefix = 'navigation-toast';

export const dataHooks = {
  actionContainer: `${prefix}-action-container`,
  text: `${prefix}-text`,
} as const;
